// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.account-passkeys-pane {
  color: var(--color-elevated-text);
  padding-right: 1rem;
  text-align: left;
}
.pane.account-passkeys-pane .title {
  font-weight: lighter;
  font-size: 1.6rem;
}
.pane.account-passkeys-pane .title em {
  font-style: normal;
  font-weight: normal;
}
.pane.account-passkeys-pane .user-registration-send-button {
  width: 13rem;
}
.pane.account-passkeys-pane .account-send-registration {
  margin: 0.5rem 1rem 1rem 0;
  padding-left: 1rem;
}
.pane.account-passkeys-pane .account-send-registration .user-registration-send {
  float: left;
  margin-right: 1rem;
}
.pane.account-passkeys-pane .account-send-registration .account-send-registration-help {
  color: var(--color-base-text);
  line-height: 2.25rem;
  margin: 0;
}
.pane.account-passkeys-pane .label-text {
  display: inline-block;
  text-align: right;
  width: 10rem;
}
.pane.account-passkeys-pane .register-passkey.tile {
  line-height: 2rem;
  padding: 2rem 0 0 0;
  margin: 2.5rem 0;
  text-align: left;
  border-top: var(--border-elevated);
}
.pane.account-passkeys-pane .register-passkey.tile .logo {
  float: left;
}
.pane.account-passkeys-pane .register-passkey.tile .help {
  float: left;
  margin: 0.2rem 1rem;
  text-align: left;
  width: 16rem;
}
.pane.account-passkeys-pane .account-passkey-card {
  border-top: var(--border-width) solid transparent;
  border-bottom: var(--border-elevated);
  margin-top: calc(-1 * var(--border-width));
  min-width: 40rem;
  padding: 1rem 0;
}
.pane.account-passkeys-pane .account-passkey-card:first-child {
  border-top: var(--border-elevated);
}
.pane.account-passkeys-pane .account-passkey-card:focus-within {
  border-color: var(--color-selected-border);
}
.pane.account-passkeys-pane .account-passkey-card:has(+ :focus-within) {
  border-bottom-color: var(--color-selected-border);
}
.pane.account-passkeys-pane .account-passkey-card.confirming input.account-passkey-name {
  color: var(--color-elevated-warn) !important;
}
.pane.account-passkeys-pane .account-passkey-card input.account-passkey-name {
  margin: 0 1rem;
  width: calc(100% - 26.3rem);
}
.pane.account-passkeys-pane .account-passkey-card .account-passkey-description {
  margin: 0 0 -0.5rem 11rem;
  color: var(--color-base-text);
  font-size: var(--font-size-input-help);
}
.pane.account-passkeys-pane .account-passkey-card .account-passkey-actions {
  display: inline-block;
}
.pane.account-passkeys-pane .account-passkey-card .account-passkey-delete {
  width: 5rem;
  margin-left: 1.5rem;
}
.pane.account-passkeys-pane .account-passkey-card .account-passkey-delete-confirmation {
  font-size: 0.8rem;
  line-height: 1.3rem;
  margin: 1rem 1rem -0.5rem 11rem;
}
.pane.account-passkeys-pane .account-passkey-sync-confirmation-backdrop {
  background-color: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  animation-name: blur-in;
  animation-duration: 0.1s;
  animation-fill-mode: forwards;
  z-index: 999;
}
.pane.account-passkeys-pane .account-passkey-sync-confirmation {
  position: absolute;
  top: calc(50% - 9.5rem);
  left: calc(50% - 17.5rem);
  z-index: 1000;
  height: 19rem;
  width: 33rem;
  background-color: var(--color-elevated-canvas);
  border: var(--border-width) solid var(--color-elevated-border);
  color: var(--color-elevated-text);
  line-height: 1.5rem;
  margin-top: -6.2rem;
  padding: 1rem;
  text-align: left;
  white-space: pre-wrap;
}
.pane.account-passkeys-pane .account-passkey-sync-confirmation .button.register {
  color: var(--color-elevated-warn);
}
.pane.account-passkeys-pane .account-passkey-sync-confirmation .account-passkey-sync-cancel {
  font-weight: bold;
  position: relative;
  top: -4.7rem;
  left: 28.3rem;
}
.pane.account-passkeys-pane .account-passkey-sync-confirmation .replacement-name {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/account/account_passkeys.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,oBAAA;EACA,iBAAA;AACJ;AACI;EACE,kBAAA;EACA,mBAAA;AACN;AAGE;EACE,YAAA;AADJ;AAGE;EACE,0BAAA;EACA,kBAAA;AADJ;AAGI;EACE,WAAA;EACA,kBAAA;AADN;AAII;EACE,6BAAA;EACA,oBAAA;EACA,SAAA;AAFN;AAME;EACE,qBAAA;EACA,iBAAA;EACA,YAAA;AAJJ;AAOE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AALJ;AAOI;EACE,WAAA;AALN;AAOI;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AALN;AASE;EACE,iDAAA;EACA,qCAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AASI;EACE,kCAAA;AAPN;AAUI;EACE,0CAAA;AARN;AAUI;EACE,iDAAA;AARN;AAaM;EACE,4CAAA;AAXR;AAeI;EACE,cAAA;EACA,2BAAA;AAbN;AAgBI;EACE,yBAAA;EACA,6BAAA;EACA,sCAAA;AAdN;AAiBI;EACE,qBAAA;AAfN;AAkBI;EACE,WAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,iBAAA;EACA,mBAAA;EACA,+BAAA;AAjBN;AAqBE;EACE,oCAAA;EACA,eAAA;EAAiB,MAAA;EAAQ,QAAA;EAAU,SAAA;EAAW,OAAA;EAC9C,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,YAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,uBAAA;EAAyB,yBAAA;EACzB,aAAA;EACA,aAAA;EACA,YAAA;EAEA,8CAAA;EACA,8DAAA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAhBJ;AAkBI;EACE,iCAAA;AAhBN;AAmBI;EACE,iBAAA;EACA,kBAAA;EAAoB,YAAA;EAAc,aAAA;AAfxC;AAkBI;EACE,iBAAA;AAhBN","sourcesContent":[".pane.account-passkeys-pane {\n  color: var(--color-elevated-text);\n  padding-right: 1rem;\n  text-align: left;\n\n  .title {\n    font-weight: lighter;\n    font-size: 1.6rem;\n\n    em {\n      font-style: normal;\n      font-weight: normal;\n    }\n  }\n\n  .user-registration-send-button {\n    width: 13rem;\n  }\n  .account-send-registration {\n    margin: 0.5rem 1rem 1rem 0;\n    padding-left: 1rem;\n\n    .user-registration-send {\n      float: left;\n      margin-right: 1rem;\n    }\n\n    .account-send-registration-help {\n      color: var(--color-base-text);\n      line-height: 2.25rem;\n      margin: 0;\n    }\n  }\n\n  .label-text {\n    display: inline-block;\n    text-align: right;\n    width: 10rem;\n  }\n\n  .register-passkey.tile {\n    line-height: 2rem;\n    padding: 2rem 0 0 0;\n    margin: 2.5rem 0;\n    text-align: left;\n    border-top: var(--border-elevated);\n\n    .logo {\n      float: left;\n    }\n    .help {\n      float: left;\n      margin: 0.2rem 1rem;\n      text-align: left;\n      width: 16rem;\n    }\n  }\n\n  .account-passkey-card {\n    border-top: var(--border-width) solid transparent;\n    border-bottom: var(--border-elevated);\n    margin-top: calc(-1 * var(--border-width));\n    min-width: 40rem;\n    padding: 1rem 0;\n\n    &:first-child {\n      border-top: var(--border-elevated);\n    }\n\n    &:focus-within {\n      border-color: var(--color-selected-border);\n    }\n    &:has(+ :focus-within) {\n      border-bottom-color: var(--color-selected-border);\n    }\n\n\n    &.confirming {\n      input.account-passkey-name {\n        color: var(--color-elevated-warn) !important;\n      }\n    }\n\n    input.account-passkey-name {\n      margin: 0 1rem;\n      width: calc(100% - 26.3rem);\n    }\n\n    .account-passkey-description {\n      margin: 0 0 -0.5rem 11rem;\n      color: var(--color-base-text);\n      font-size: var(--font-size-input-help);\n    }\n\n    .account-passkey-actions {\n      display: inline-block;\n    }\n\n    .account-passkey-delete {\n      width: 5rem;\n      margin-left: 1.5rem;\n    }\n\n    .account-passkey-delete-confirmation {\n      font-size: 0.8rem;\n      line-height: 1.3rem;\n      margin: 1rem 1rem -0.5rem 11rem;\n    }\n  }\n\n  .account-passkey-sync-confirmation-backdrop {\n    background-color: rgba(0, 0, 0, 0.1);\n    position: fixed; top: 0; right: 0; bottom: 0; left: 0;\n    animation-name: blur-in;\n    animation-duration: 0.1s;\n    animation-fill-mode: forwards;\n    z-index: 999;\n  }\n\n  .account-passkey-sync-confirmation {\n    position: absolute;\n    top: calc(50% - 9.5rem); left: calc(50% - 17.5rem);\n    z-index: 1000;\n    height: 19rem;\n    width: 33rem;\n\n    background-color: var(--color-elevated-canvas);\n    border: var(--border-width) solid var(--color-elevated-border);\n    color: var(--color-elevated-text);\n    line-height: 1.5rem;\n    margin-top: -6.2rem;\n    padding: 1rem;\n    text-align: left;\n    white-space: pre-wrap;\n\n    .button.register {\n      color: var(--color-elevated-warn);\n    }\n\n    .account-passkey-sync-cancel {\n      font-weight: bold;\n      position: relative; top: -4.7rem; left: 28.3rem;\n    }\n\n    .replacement-name {\n      font-weight: bold;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
